// removed by extract-text-webpack-plugin
module.exports = {"resume-view":"_3aJpBz3z","resumeView":"_3aJpBz3z","download":"_3XMJt2y1","bounce":"_2nd-1b-B","resume-header":"_2UOL3Gk7","resumeHeader":"_2UOL3Gk7","paper":"_2yfpD6dV","content":"_287lDigR","right-col":"EU7RpyAS","rightCol":"EU7RpyAS","experience":"_2E4HfLLT","skills":"_29lTIUgh","education":"opV6h61I","tag":"_2fWA2bEr"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ResumeView/ResumeView.pcss
// module id = 1012
// module chunks = 0